import React, { useState, useEffect, useContext } from "react";
import { MapContainer, TileLayer, useMap, useMapEvents } from "react-leaflet";
import { Switch, Space, Checkbox } from "antd";
import "leaflet/dist/leaflet.css";
import MANUAL_ROAD_CLOSURE_MBTN from "assets/roadclosure.png";
import {
  HiOutlineArrowsPointingOut,
  HiOutlineArrowsPointingIn,
} from "react-icons/hi2";
import { FaCrosshairs, FaList, FaX } from "react-icons/fa6";

export default function FullScreenMap({
  children,
  mapCenter,
  zoom,
  maxBounds,
  maxBoundsViscosity,
  minZoom,
  maxZoom,
  setView,
  style,
  container,
  satelliteToggleStyle,
  mobile = false,
  onZoomEnd = () => {},
  onMoveEnd = () => {},
  onDragEnd = () => {},
  fullscreen,
  onFullscreen,
  setShowMobileDevices,
  setCalcZoom,
  setCalcCenter,
  _initialMapCenter,
  _initialMapZoom,
  setMapZoom = () => {},
  setMapCenter = () => {},
}) {
  const ORIGINAL_MAP_CENTER = mapCenter;
  const ORIGINAL_ZOOM = zoom;
  const [satelliteView, setSatelliteView] = useState(false);
  const [labelsEnabled, setLabelsEnabled] = useState(true);

  const mapStyle = {
    width: "100%",
    height: "100%",
    ...style,
  };

  const containerStyle = {
    display: "flex",
    height: "100%",
    // paddingBottom: 85,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    zIndex: 0,
    // backgroundColor: "#0b1826",
    ...container,
  };

  // console.log("Fullscreen inside <FullscreenMap>", fullscreen);

  return (
    <div style={containerStyle}>
      <MapContainer
        style={mapStyle}
        center={mapCenter}
        zoom={zoom}
        maxBounds={maxBounds}
        maxBoundsViscosity={maxBoundsViscosity}
        minZoom={minZoom}
        maxZoom={maxZoom}
        setView={setView}
        mapEvents={{
          moveend: () => console.log("Move end"),
          zoomend: () => console.log("Zoom end"),
        }}
      >
        <MapEvents onZoomEnd={onZoomEnd} onMoveEnd={onMoveEnd} onDragEnd={onDragEnd} />
        {satelliteView ? (
          <TileLayer
            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
            attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
          />
        ) : (
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          />
        )}
        {labelsEnabled && satelliteView && (
          <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}" />
        )}
        {children}
      </MapContainer>
      <Space
        style={{
          position: "absolute",
          bottom: mobile
            ? satelliteView
              ? "45px"
              : "25px"
            : fullscreen
            ? "100px"
            : "10px",
          left: mobile ? "auto" : "10px",
          right: mobile ? "10px" : "auto",
          zIndex: 999,
          pointerEvents: "auto",
          ...satelliteToggleStyle,
        }}
      >
        {satelliteView && mobile && (
          <Checkbox
            onChange={() => setLabelsEnabled(!labelsEnabled)}
            checked={labelsEnabled}
          >
            <p
              style={
                {
                  // color: theme.fontColor
                }
              }
            >
              Labels
            </p>
          </Checkbox>
        )}
        <Switch
          checkedChildren="Map"
          unCheckedChildren="Satellite"
          checked={!satelliteView}
          onChange={() => setSatelliteView(!satelliteView)}
        />
        {!mobile && (
          <div>
            <button
              onClick={() => {
                console.log(
                  "Resetting map view",
                  _initialMapCenter,
                  _initialMapZoom
                );
                setMapCenter(_initialMapCenter);
                setMapZoom(_initialMapZoom);
              }}
            >
              Reset
            </button>
          </div>
        )}
        {satelliteView && !mobile && (
          <Checkbox
            onChange={() => setLabelsEnabled(!labelsEnabled)}
            checked={labelsEnabled}
          >
            <p
              style={
                {
                  // color: theme.fontColor
                }
              }
            >
              Labels
            </p>
          </Checkbox>
        )}
      </Space>
      {onFullscreen && (
        <Space
          style={{
            position: "absolute",
            top: fullscreen ? 150 : 15,
            right: 15,
            zIndex: 999,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 12,
            }}
          >
            {fullscreen && (
              <div
                style={{
                  backgroundColor: "#436c9a",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  borderRadius: 15,
                  border: "none",
                  color: "white",
                  padding: 8,
                }}
                onClick={() => {
                  setShowMobileDevices(true);
                  console.log("press");
                }}
              >
                <FaList
                  size={24}
                  style={{
                    color: "white",
                  }}
                />
              </div>
            )}
            <button
              style={{
                backgroundColor: "#436c9a",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                borderRadius: 15,
                border: "none",
                color: "white",
                padding: 5,
              }}
              onClick={onFullscreen}
            >
              {fullscreen ? (
                <HiOutlineArrowsPointingIn size={30} />
              ) : (
                <HiOutlineArrowsPointingOut size={30} />
              )}
            </button>
          </div>
          <button
            style={{
              backgroundColor: "#436c9a",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              borderRadius: 15,
              border: "none",
              color: "white",
              padding: 5,
              marginTop: 2,
            }}
            onClick={() => {
              console.log("Centering map on current location");
              setMapCenter(ORIGINAL_MAP_CENTER);
              setMapZoom(ORIGINAL_ZOOM);
            }}
          >
            {<FaCrosshairs size={30} />}
          </button>
        </Space>
      )}
    </div>
  );
}

function MapEvents({ onZoomEnd, onMoveEnd, onDragEnd }) {
  const mapEvents = useMapEvents({
    zoomend: () => {
      onZoomEnd(mapEvents.getZoom());
    },
    moveend: () => {
      onMoveEnd(mapEvents.getCenter());
    },
    dragend: () => {
      onDragEnd(mapEvents.getCenter());
    },
  });

  return null;
}
